// src/utils/exportExcel.js
import * as XLSX from "xlsx";

export function exportarReporteExcel({ clientes, historial, stats, porAsesor, periodo }) {
  const wb    = XLSX.utils.book_new();
  const fecha = new Date().toLocaleDateString("es-PE");

  // Hoja 1: Resumen
  const wsRes = XLSX.utils.aoa_to_sheet([
    ["REPORTE PROVEXO+ CRM", "", ""],
    ["Generado:", fecha, ""],
    ["Período:", periodo, ""],
    ["", "", ""],
    ["INDICADORES CLAVE", "", ""],
    ["Total clientes",     stats.total,            ""],
    ["Clientes cerrados",  stats.cerrados.length,  ""],
    ["Tasa de conversión", `${stats.conversion}%`, ""],
    ["Ingresos cerrados",  stats.ingresos,         "S/"],
    ["Pipeline activo",    stats.pipelineVal,      "S/"],
    ["Valor perdido",      stats.perdidoVal,       "S/"],
  ]);
  wsRes["!cols"] = [{wch:25},{wch:20},{wch:8}];
  XLSX.utils.book_append_sheet(wb, wsRes, "Resumen");

  // Hoja 2: Clientes
  const wsCli = XLSX.utils.aoa_to_sheet([
    ["Nombre","Empresa","Proyecto","Estado","Valor (S/)","Responsable","Ciudad","Próx. Seguimiento"],
    ...(clientes||[]).map(c => [
      c.nombre||"", c.empresa||"", c.proyecto||"", c.estado||"",
      Number(c.valor||0), c.responsable||"", c.ciudad||"", c.proximoSeguimiento||"",
    ])
  ]);
  wsCli["!cols"] = [{wch:25},{wch:25},{wch:30},{wch:14},{wch:12},{wch:20},{wch:12},{wch:18}];
  XLSX.utils.book_append_sheet(wb, wsCli, "Clientes");

  // Hoja 3: Historial
  const wsHis = XLSX.utils.aoa_to_sheet([
    ["Fecha","Cliente","Empresa","Proyecto","Estado","Valor (S/)","Asesor","Comentario"],
    ...(historial||[]).map(h => {
      const d = h.fecha?.toDate ? h.fecha.toDate() : new Date(h.fecha||0);
      return [
        d.toLocaleDateString("es-PE"),
        h.nombre||"", h.empresa||"", h.proyecto||"", h.estadoFinal||"",
        Number(h.valor||0), h.responsable||"", h.comentario||"",
      ];
    })
  ]);
  wsHis["!cols"] = [{wch:14},{wch:25},{wch:25},{wch:30},{wch:12},{wch:12},{wch:20},{wch:40}];
  XLSX.utils.book_append_sheet(wb, wsHis, "Historial");

  // Hoja 4: Por Asesor
  const wsAse = XLSX.utils.aoa_to_sheet([
    ["Asesor","Total Clientes","Cerrados","Conversión (%)","Valor Cerrado (S/)"],
    ...(porAsesor||[]).map(a => [
      a.nombre, a.total, a.cerrados,
      a.total > 0 ? Number(((a.cerrados/a.total)*100).toFixed(1)) : 0,
      a.valor,
    ])
  ]);
  wsAse["!cols"] = [{wch:25},{wch:14},{wch:12},{wch:16},{wch:20}];
  XLSX.utils.book_append_sheet(wb, wsAse, "Por Asesor");

  XLSX.writeFile(wb, `Reporte_PROVEXO_${fecha.replace(/\//g,"-")}.xlsx`);
}
